// extracted by mini-css-extract-plugin
export default {"adminFeeInfoBlock":"_6fROjECpNMsOGxc31VxS8Q=="};